import React from "react";
import shared from "./shared.module.scss";
import ChevronDown from "../../../../static/images/ChevronDown.svg";

export const SelectField = ({ label, required, value, onChange, options = [], placeholder = "Select an option", error, id }) => {
  return (
    <div className={shared.field}>
      <label className={shared.label} htmlFor={id}>
        {label}
        {required && <span className={shared.required}>*</span>}
      </label>
      <div className={shared.inputWrap}>
        <select
          id={id}
          className={`${shared.select} ${error ? shared.inputError : ""}`}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          aria-invalid={!!error}
          aria-required={required}
        >
          <option value="" disabled>
            {placeholder}
          </option>
          {options.map((opt) => (
            <option key={opt.key} value={opt.key}>
              {opt.value}
            </option>
          ))}
        </select>
        <span className={shared.selectChevron}>
          <img src={ChevronDown} alt="Chevron Down" />
        </span>
      </div>
      {error && <span className={shared.errorText}>{error}</span>}
    </div>
  );
};
